import http from '@/communication/AuthConnection'

export default async ({ commit }) => {
  try {
    const request = await http.get('/v1/cbpf/list-fisical-forms')
    return request.data
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/brain/record/cbpf/list-fisical-forms/index.js